const styles = `
<style>
.logo  {max-width: 150px; position: relative; left: 0px} 
nav.aaac-nav {position: relative; right: 0px; } 



.simple-nav  {
	width: 100%;
	display: block;
	border: 1px solid #bbb;	
	}

.simple-nav a {
	background: linear-gradient(to bottom, 0%,#e0e0e0 100%);
	display: block;
    font-weight: bold;
    padding: 8px 15px;
    
    border-bottom: 1px solid #bbbbbb;
    color: #666666;
	
}


footer { border-top:1px solid #bbb; margin-top: 15px; background: #eee} 

.subfooter p { background: red; width: 100%; padding: 2em; color: #fff; } 


@media (min-width: 780px) {	

.simple-nav  {
	border: 0;
	margin-top: 2em;
	}

.simple-nav a {
	background: none;
	display: inline-block;
   width:7em;
   border-bottom: 0;
   border-right: 1px solid #bbb;
   color: #00338d;
   text-align: center;
   font-size: 0.8em;
   padding: 8px 10px;
	
}

.simple-nav a:last-child { border: 0 } 


footer .simple-nav { margin:15px auto }
footer .simple-nav a {width: 9em }

}


h2, .splash h3 {
    color: #000;
    font-size: 2em;
    font-weight: 700; }

/*TMIC overrides*/
html, body, p, h1, h2, h3, input, button, a { font-family: 'Ubuntu', sans-serif; }
.mainfooter { margin-top: 2%; background: #eee; border: 0; text-align: center; border-bottom: 1px solid #bbb} 

.footernav-con { display: inline-block; border-top: 1px solid #bbb; border-bottom: 0; padding-bottom: 10px; width: 100% } 

/* homepage */
.splash { text-align: left; background: url(<?php theme_img();?>/insurance/tmic/header_home.jpg);  background-size: cover; margin-top:2%; background-repeat: no-repeat; margin: 0} 
.splash h1 { text-transform: capitalize }
.section { padding: 1%; }
.section.row { padding: 5% 0 } 

.splash h2 { font-size: 20px; padding-bottom: 2% }

#btnFindAgent { font-size: 16px; line-height: 1.42857; } 

.tmicSubheader { text-align: left; background: #ddeeff; font-size: 24px } 

#PolicySelect { border-width: 0px; padding: 3px; border-radius: 5px; width: 340px; height: 40px; font-size: 24px; font-weight: 200; margin-right: 10px; display: inline-block; vertical-align: baseline; }

.tmicSubheader a.btn { vertical-align: baseline; font-size: 16px } 

.tmicSubheader select { border-width: 0px; padding: 3px; border-radius: 5px; width: 340px; height: 40px; font-size: 24px; font-weight: 200; margin-right: 10px; }

@media screen and (max-width: 600px) {
	
	.splash, .section { padding: 3%; } 
	.splash .btn-secondary, .tmicSubheader .btn-secondary { font-size: 20px; width: 80%; }
	input, select { width: 80%; margin: 2% auto } 
	.tmicSubheader {  text-align: center;  } 
	.tmicSubheader select { width: 80% } 
	.section .btn-secondary { font-size: 20px } 
	.footernav-con { width: 100%;}
	.footer-nav > li {
    width: 100%; }
	
	#copyrightYear { display: inline } 
}

@media screen and (min-width: 600px) {
.splash input { display: inline-block; max-width: 200px } 
}


.utilitybar { 
    position: absolute;
    top: 0; 
    left: 0;
    width: 100%;
    height: 25px; 
    background: #dddddd;
    padding: 0 25px; 
    box-sizing: border-box;
}

.backtoAAA, .call { font-size: 13px; position: relative; height: auto; }
.call { float: right; padding-top: 2px;}

/* pad top to accommodate utility bar */
.outer-chrome { padding-top: 25px; }




/* Nav tweaks! */
#mob-menu-button, #mob-menu-close-button { display: none; }

/*  Homepage  */
.splash { background: url(<?php theme_img();?>/insurance/tmic/ins-hero-banner1.jpg);  background-size: cover ; padding: 5% 0; background-repeat: no-repeat;} 

.quoteblock { 
    width: 100%;
    max-width: 400px; 
    background: rgba(255,255,255,.9);
    padding: 20px; 
    box-sizing: border-box; 
    margin: auto; 
    text-align: center; 
    border-top: 2px solid #00338d;
}

.quoteblock h2 { 
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 0;
    padding-bottom: 5px;
}

.quoteblock .btn { 
    display: block; 
    margin: 10px auto; 
    font-size: 16px; 
}

.searchdiv { display: block; position: relative; }

.searchA { 
   display: block !important; 
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box; 
    margin: 5px 0;
    padding: 10px !important;
    border-radius: 3px;
}

#aSearch { 
    position: absolute;
    display: inline-block; 
    border: 0; 
    background: none; 
    top: 4px;
    right: 4px;
    color: #00338d;
}

#aSearch:hover { 
    background: none; 
}

.claimsBar { 
    position: relative;
    padding: 20px; 
    border-top: 2px solid #bbbbbb; 
    border-bottom: 2px solid #bbbbbb; 
    
    /* flex styling */
    display: flex;
    flex-direction: column; 
    justify-content: center;
    align-items: center;
    
    
/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#dddddd+0,ffffff+50,dddddd+100 */
background: #dddddd; /* Old browsers */
background: -moz-linear-gradient(left, #dddddd 0%, #ffffff 50%, #dddddd 100%); /* FF3.6-15 */
background: -webkit-linear-gradient(left, #dddddd 0%,#ffffff 50%,#dddddd 100%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(to right, #dddddd 0%,#ffffff 50%,#dddddd 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dddddd', endColorstr='#dddddd',GradientType=1 ); /* IE6-9 */
}
.claimsBar div { padding: 10px; max-width: 330px;}
.claimsBar h3 { margin: 0; padding: 10px 0;}
.claimsBar .btn { font-size: 20px;}

.clipped { display: none; }

@media screen and (min-width: 600px){ 
    .claimsBar { flex-direction: row; overflow: hidden; }
    .claimsBar div { padding: 10px;}
} 
@media screen and (min-width: 900px){ 
    .clipped { 
        display: block; 
        position: absolute; 
        right: 5%;
        top: -25%;
        height: auto;
        width: 400px;
    }
	
	header { min-height: 150px; margin-bottom: 2em}
}



/* homepage: products tabs */ 
.productTabs { 
    background: #f1f1f1;
    border: 1px solid #bbbbbb;
    border-radius: 4px; 
    box-sizing: border-box;
    margin: 20px auto;
    width: 90%;
    max-width: 1000px;
    position: relative;
    height: 300px;
    
} 
.ptab-label {
    display: block; 
    width: 50px;
    background: #e1e1e1;
    border-right: 1px solid #bbbbbb;
    border-bottom: 1px solid #bbbbbb;
    height: 49px;
    position: relative;
    z-index: 99;
    cursor: pointer;
}

.pTabs-auto > .ptab-label { border-radius: 4px 0 0 0; } /*  tweak radius */
.pTabs-more > .ptab-label { border-bottom: 0; border-radius: 0 0 0 4px; height: 48px; } /* remove last tab's border, tweak radius*/

.ptab-active { background: #d1d1d1; z-index: 100; }

.ptab-active:after, .ptab-active:before {
	left: 100%;
	top: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.ptab-active:after {
	border-color: rgba(221, 221, 221, 0);
	border-left-color: #d1d1d1;
	border-width: 23px;
	margin-top: -23px;
}
.ptab-active:before {
	border-color: rgba(187, 187, 187, 0);
	border-left-color: #bbbbbb;
	border-width: 25px;
	margin-top: -25px;
}

.pTab-icon {
    max-width: 40px !important; 
    height: auto;
    position: absolute;
    top: -5px;
    left: 5px;
}

.pTabs-auto .pTab-icon { top: -6px; } /* tweak car icon */

.more-icon { 
    position: relative; 
    top: auto;
    left: auto;
    font-size: 28px !important;
    color: #00338d;
    margin-left: 13px;
    margin-top: 10px;
}
.pTab-text {
    display: none;
}

.ptab-content {
    display: block;
    position: absolute; 
    left:  70px; 
    top: 0;
    padding: 10px 20px 10px 10px; 
    z-index: 10;
}

.ptab-content h3 { margin: 0; padding: 0; font-size: 20px; }
.ptab-content p { font-size: .9em; line-height: 1.3; }

@media screen and (min-width: 500px) { 
    .ptab-content h3 { margin: 2; padding: 2; font-size: 24px; }
    .ptab-content p { font-size: 1em; line-height: 1.4; }
}

@media screen and (min-width: 700px) { 
    
    .productTabs { height: 235px; }
    .ptab-label { width: 175px; height: 38px; }
    .pTabs-more > .ptab-label { border-bottom: 0; border-radius: 0 0 0 4px; height: 38px; } /* remove last tab's border, tweak radius*/

    .pTab-icon { top: -9px; left: 5px; }
    .pTabs-auto .pTab-icon { top: -13px; } /* tweak car icon */
    .more-icon { margin-left: 10px; margin-top: 15px; font-size: 22px !important;} 
    
    .ptab-content { left: 200px; } 
    
    .pTab-text {
        display: block;
        position: absolute;
        left: 60px;
        top: 7px; 
    }
    
    /* Arrow fixes for tabs */ 
    .ptab-active:after {
	border-color: rgba(221, 221, 221, 0);
	border-left-color: #d1d1d1;
	border-width: 18px;
	margin-top: -18px;
    }
    .ptab-active:before {
	border-color: rgba(187, 187, 187, 0);
	border-left-color: #bbbbbb;
	border-width: 20px;
	margin-top: -20px;
    }
}

/* homepage: why block */

.hp-whyAAA { 
    padding: 7% 0; 
    border-top: 1px solid #bbbbbb;
    border-bottom: 1px solid #bbbbbb; 
    background: url(<?php theme_img();?>/insurance/tmic/ins-why-banner1.jpg) center center no-repeat; 
    background-size: cover;
	margin: 3% 0;
}
.hp-whyAAA-text { 
    padding: 20px;
    max-width: 280px; 
    margin: 0 auto; 
}

.hp-whyAAA-text h3 { margin-top: 0; }

@media screen and (min-width: 600px) { 
    .hp-whyAAA-text { 
        margin-right: 10%;  
    }
}

/* homepage: social */
	.splash .flexbtn { width: 100% } 
.hp-social { margin: 25px auto;}

.social-block { 
    vertical-align: top;
    display: block; 
    max-width: 300px; 
    margin: 25px auto;
}

.social-img { max-width: 300px !important; height: auto; border-radius: 3px; }
.social-content h4 { 
    font-size: 14px; 
    color: #000000; margin: 5px 0 0 0; padding: 0;
}
.social-content p { font-size: 14px; line-height: 1.3; }
.social-content a { color: #00338d; font-weight: bold; }

@media screen and (min-width: 500px) { 
    .hp-social-half { margin: auto; width: 500px; }
    .social-block { 
    display: inline-block; 
    max-width: 200px; 
    margin: 15px;
    }
    .social-img { max-width: 200px !important; height: auto; }
}

@media screen and (min-width: 1200px) { 
    .hp-social-half:first-child { width: auto; display: inline-block; }
    .hp-social-half:last-child { width: auto; display: inline-block; margin: auto 100px auto auto ; }
}

/* Products page! */
.coverage { 
    padding: 10px; 
    border: 1px solid #bbbbbb;
    background: #f1f1f1;
    border-radius: 3px;
    display: none;
}

.coverage-title { 
    font-weight: bold; 
    color: #777;
    display: block;
    cursor: pointer;
}

.i-rotate { 
    transform:  rotate(90deg);
}

/* Policy Search page */
.policy-search { 
    display: block; 
}

.policy-search div { 
    width: 100%;
    max-width: 400px; 
    margin: auto; 
}

.policy-search input { 
    display: block; 
    width: 100%;
    box-sizing: border-box; 
    margin: 10px auto;
    padding: 10px;
    border-radius: 3px;
}

.policy-search .btn-block { 
    border-radius: 4px;
}

</style>
<script>
$(document).ready(function () {

    //  --------------- New code for Insurance redesign
    
    // Click 
    $(".coverage-title").click(function() {
        var $c = $(this);
        var $n = $c.next(".coverage");
        
        if ( $n.is(":visible") ){ 
            $c.find("i").removeClass("i-rotate");
            $n.slideUp();
        } else { 
            $c.find("i").addClass("i-rotate");
            $n.slideDown();
        }
        
    });
    

    // homepage products tabs
    $(".ptab-content").hide();
    
    // Click function for tabs
    $(".ptab-label").click(function(){ 
        
        if (  $(this).next(".ptab-content").is(":visible") ){ 
            // do nothing
        } else { 
            // cancel previous actions
            $(".ptab-label").removeClass("ptab-active");
            $(".ptab-content").hide();
            // complete new actions
            $(this).next(".ptab-content").show();
            $(this).addClass("ptab-active");
        }
    }); 
    
    $(".pTabs-auto .ptab-label").click();
    
    
    
});



</script>
`;

export default styles;
